// extracted by mini-css-extract-plugin
export var errorIcon = "_jk-1";
export var nameLogo = "_jk-0";